/* This code is checking if the left sidebar is visible. If it is, it will add event listeners to the
links in the sidebar. When the links are clicked, the page will scroll to the corresponding section. */

const leftBar = document.querySelector(".sidebar-left-bar");
if (leftBar && window.getComputedStyle(leftBar).display !== "none") {
/* Adding an event listener to each link in the left sidebar. When the link is clicked, the page will
scroll to the corresponding section. */
  const links = document.querySelectorAll("a[data-option-style='scroll']");
  links.forEach((link, index) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: document.getElementById(`title-${index}`).offsetTop,
        behavior: "smooth",
      });
    });
  });

  /* Adding an event listener to the window. When the window is scrolled, the function will be called. */
  window.addEventListener("scroll", function () {
    // Check if the page is scrolled to the top
    if (window.scrollY === 0) {
      leftBar.style.top = "0%";
    }
    // Check if the page is scrolled to the bottom
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      // leftBar.style.top = "10%";
    }
    // The page is being scrolled
    leftBar.style.top = "10%";
  });
}
/**
 * It takes the selected option from the mobile menu, and then it either scrolls to the selected title,
 * or it redirects to the selected URL
 */
function mobileOptionSelect() {
  let selectBox = document.getElementById("select_mobile_options");
  let selectedOption = selectBox.options[selectBox.selectedIndex];
  let optionStyle = selectedOption.getAttribute("data-option-style");
  switch (optionStyle) {
    case "scroll":
      let optionPosition = selectedOption.getAttribute(
        "data-option-title-position"
      );
      window.scrollTo({
        top: document.getElementById(`title-${optionPosition}`).offsetTop,
        behavior: "smooth",
      });
      break;
    case "redirect":
      let optionUrl = selectedOption.getAttribute("data-option-url");
      let optionTab = JSON.parse(selectedOption.getAttribute("data-option-ootag"));
      if (optionUrl) {
        if (optionTab) {
          window.open(optionUrl, "_blank");
        } else {
          window.location.href = optionUrl;
        }
      }
      break;
    default:
      break;
  }
}
